import React from 'react';

export const name = 'community';

export const Community = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.55371 11.9953V8.27155H5.92871"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M5.42236 15.9947V12.6197H9.18549"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M15.4463 11.9953V8.27155H12.0713"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M12.572 15.9947V12.6197H9.19702"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M9.05618 10.5553C10.1528 10.5553 11.0418 9.6663 11.0418 8.56967C11.0418 7.47304 10.1528 6.58405 9.05618 6.58405C7.95955 6.58405 7.07056 7.47304 7.07056 8.56967C7.07056 9.6663 7.95955 10.5553 9.05618 10.5553Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M4.53934 5.97656C5.63597 5.97656 6.52496 5.08757 6.52496 3.99094C6.52496 2.8943 5.63597 2.00531 4.53934 2.00531C3.44271 2.00531 2.55371 2.8943 2.55371 3.99094C2.55371 5.08757 3.44271 5.97656 4.53934 5.97656Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <path
      d="M13.4607 5.97656C14.5574 5.97656 15.4463 5.08757 15.4463 3.99094C15.4463 2.8943 14.5574 2.00531 13.4607 2.00531C12.3641 2.00531 11.4751 2.8943 11.4751 3.99094C11.4751 5.08757 12.3641 5.97656 13.4607 5.97656Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
  </svg>
);
